export default __webpack_public_path__ + "static/desktop_3-2e71f8c775f4d8207a6fc920936c084a.webp";